import { useEffect, useRef, useState } from "react";
import { Smiley } from "@phosphor-icons/react";

// Small curated emoji palette — kept simple to avoid extra deps and to sidestep
// the known webpack/babel issue with heavy emoji picker packages.
const EMOJIS = [
  "😀", "😁", "😂", "🤣", "😊", "😍", "😘", "😜", "🤩", "🥰",
  "😎", "🤔", "😴", "😭", "😢", "😡", "🤯", "😱", "🥳", "🤗",
  "👍", "👎", "👏", "🙏", "💪", "🤝", "🙌", "✌️", "🤞", "👋",
  "❤️", "💔", "💯", "🔥", "✨", "⭐", "🌟", "💥", "🎉", "🎊",
  "💰", "💵", "💸", "🤑", "💎", "🏆", "🥇", "🎯", "📈", "📊",
  "🚀", "⚡", "☀️", "🌈", "☕", "🍕", "🎁", "🎈", "❓", "❗",
];

export default function EmojiPicker({ onPick, className = "" }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div ref={wrapRef} className={`relative ${className}`}>
      <button
        type="button"
        data-testid="emoji-picker-toggle"
        onClick={() => setOpen((v) => !v)}
        className="h-9 w-9 inline-flex items-center justify-center rounded-full text-slate-500 hover:text-yellow-500 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors duration-200"
        aria-label="Insert emoji"
        title="Insert emoji"
      >
        <Smiley size={20} weight="bold" />
      </button>
      {open && (
        <div
          data-testid="emoji-picker-panel"
          className="absolute z-30 bottom-full right-0 mb-2 w-64 max-h-56 overflow-y-auto rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-xl p-2 grid grid-cols-8 gap-1"
        >
          {EMOJIS.map((em, i) => (
            <button
              key={`${em}-${i}`}
              type="button"
              data-testid={`emoji-${i}`}
              onClick={() => { onPick(em); setOpen(false); }}
              className="text-lg h-8 w-8 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 hover:scale-125 transition-transform duration-150"
            >
              {em}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
